export default __webpack_public_path__ + "static/media/mobile.4fc128b7.jpg";